export default __webpack_public_path__ + "static/191-c502b5be3d189a652786fab307fe7c91.jpg";